import React from 'react';
import { getAPI, postAPI } from '../utils/APIUtils';
import { downloadData, uploadData } from 'aws-amplify/storage';

import { styled } from '@mui/material/styles'

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';
import ReplayIcon from '@mui/icons-material/Replay';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LabelIcon from '@mui/icons-material/Label';
import NoteIcon from '@mui/icons-material/Note';
import Divider from '@mui/material/Divider';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DriveFileMoveOutlineIcon from '@mui/icons-material/DriveFileMoveOutline';
// import MoveDownIcon from '@mui/icons-material/MoveDown';
// import MoveUpIcon from '@mui/icons-material/MoveUp';
import DeleteIcon from '@mui/icons-material/Delete';

import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { State, Field, Act } from '../states/settingState';
import { FieldUpdateForJSONDialog } from './FieldUpdateForJSONDialog';
import { FieldUpdateMoveActDialog } from './FieldUpdateMoveActDialog';
import { FieldUpdateAddFieldDialog } from './FieldUpdateAddFieldDialog';
import { FieldUpdateNameDialog } from './FieldUpdateNameDialog';

type Props = {
  filedState: State | undefined;
  fields?: Field[];
  maxFieldId: number;
  accountid: string;
  idid: string;
  role: string;
  handleCommit: (fileName: string) => void;
  renewFieldState: () => void;
  renewFields: (fs: Field[]) => void;
  setMaxFieldId: (id: number) => void;
  setLoading: (loading: boolean) => void;
};

const FieldListItem = styled(ListItem)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  paddingLeft: theme.spacing(0),
}));

const FIELD_DIVISION_NUM = 100;
const getDivisionFields = (fs: Field[]) => {
  const ncs = fs.map((f) => {
    return f.acts.length;
  });

  const result: Field[][] = [];
  let sub: Field[] = [];
  let subCount = 0;
  ncs.forEach((n, i) => {
    sub.push(fs[i]);
    subCount += n;
    if (subCount > FIELD_DIVISION_NUM) {
      result.push(sub);
      sub = [];
      subCount = 0;
    }
  });
  if (sub.length > 0) {
    result.push(sub);
  }
  return result;
};

export const FieldUpdatePanel: React.FC<Props> = (props) => {

  const downloadFormLGWAN = async (path: string) => {
    const apiurl = `/tempfile?path=private/${props.idid}/${path}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const downloadForm = async (path: string) => {
    const downloadTask = await downloadData({
      path: `private/${props.idid}/${path}`,
    });
    const { body } = await downloadTask.result;
    const blob = new Blob([await body.blob()]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const handleLastResultDownload = async () => {
    if (props.filedState && props.filedState.outPath) {
      props.setLoading(true);

      try {
        const tmp: string = props.filedState.outPath;
        const newOutPath = tmp.replace(/private\/.*?\//, '');
        if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
          downloadFormLGWAN(newOutPath);
        } else {
          downloadForm(newOutPath);
        }

      } catch (e) {
        // エラー
        console.log(e);
      }

      props.setLoading(false);
    }
  };
  const handleRenewFieldState = () => {
    props.setLoading(true);
    props.renewFieldState();
  };

  const [subDialog, setSubDialog] = React.useState(false);
  const openSubDialog = Boolean(subDialog);
  const closeSubDialog = () => setSubDialog(false);

  const handleFieldUpdateForJSON = () => {
    setSubDialog(true);
  };

  const fTree = (level: number, fs: Field[], view: React.JSX.Element[]) => {
    fs.forEach((f, index) => {
      if (f.id === '9999') return;
      view.push((
        <Paper key={`catalogs-${level}-${f.id}`}
          sx={{
            minWidth: 275,
            margin: 1,
          }} elevation={3}>
          <List>
            {createField(f)}
          </List>
        </Paper>
      ));

      if (f.acts && f.acts.length > 0) {
        createActs(level, f.id, f.acts, view);
      }
    });
  };

  const getTimestump = () => {
    const date = new Date();
    const yyyy = `${date.getFullYear()}`;
    const MM = `0${date.getMonth() + 1}`.slice(-2); // getMonth()の返り値は0が基点
    const dd = `0${date.getDate()}`.slice(-2);
    const HH = `0${date.getHours()}`.slice(-2);
    const mm = `0${date.getMinutes()}`.slice(-2);
    const ss = `0${date.getSeconds()}`.slice(-2);

    return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
  };

  const handleCommit = async () => {
    props.setLoading(true);
    const fileName = 'Field_' + getTimestump() + '.json';

    if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
      const apiurl = `/tempfile`;
      const options = {
        path: `private/${props.idid}/${fileName}`,
        contenttype: 'application/json',
      };
      const json = await postAPI(apiurl, options);
      const realuploadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.uploadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.uploadUrl;

      const uploadResponse = await fetch(realuploadurl, {
        method: 'PUT',
        body: JSON.stringify(props.fields),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!uploadResponse.ok) {
        console.error('アップロード失敗', uploadResponse.status, uploadResponse.statusText);
      }

    } else {
      await uploadData({
        path: `private/${props.idid}/${fileName}`,
        data: JSON.stringify(props.fields),
      });
    }

    props.handleCommit(fileName);
  };

  const [subDialog2, setSubDialog2] = React.useState(false);
  const openSubDialog2 = Boolean(subDialog2);
  const closeSubDialog2 = () => setSubDialog2(false);
  const okSubDialog2 = () => {
    closeSubDialog2();
    handleCommit();
  };

  const confirmationCommit = () => {
    setSubDialog2(true);
  };

  const createCommitButton = () => {
    return (
      <Button variant="contained" color={'secondary'} endIcon={<SendIcon />} onClick={confirmationCommit}>
        登録
      </Button>
    );
  };

  const [currentPage, setCurrentPage] = React.useState(1);
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  const createTree = () => {
    const view: React.JSX.Element[] = [];
    if (props.fields) {
      const vFields = getDivisionFields(props.fields);
      fTree(0, vFields[currentPage - 1], view);

      return (
        <>
          {createCommitButton()}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 1 }}>
            <Pagination count={vFields.length} page={currentPage} color="secondary" onChange={handleChange} />
          </Box>
          {view}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', margin: 1 }}>
            <Pagination count={vFields.length} page={currentPage} color="secondary" onChange={handleChange} />
          </Box>
          {createCommitButton()}
        </>
      )
    }
    return (
      <>
        {view}
      </>
    );
  };

  const createFieldUpdateForJSON = () => {
    return props.role === 'Manager' ? (
      <>
        <Link component="button" underline="always" color={'secondary'} onClick={handleFieldUpdateForJSON}>設定ファイルから分野を更新</Link>
        <br />
      </>
    ) : '';
  };

  const createContents = () => {
    if (props.filedState && props.filedState.state === 'Processing') {
      return (
        <>
          <Typography variant="body1" component="span">分野の更新中です。</Typography>
          <Tooltip title="更新">
            <IconButton size={'large'} sx={{
              color: (theme) => theme.palette.secondary.main,
              position: 'relative',
              left: 5,
            }} edge="end" aria-label="enforcedate" onClick={handleRenewFieldState}>
              <ReplayIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </>
      );
    } else if (props.filedState && props.filedState.state === 'Accepting') {
      if (Array.isArray(props.fields)) {
        const lastResult = props.filedState.outPath ? (
          <>
            <Typography variant="body1" component="span">前回の実行結果をダウンロード</Typography>
            <Tooltip title="ダウンロード">
              <IconButton size={'large'} sx={{
                color: (theme) => theme.palette.secondary.main,
                position: 'relative',
                left: 5,
              }} edge="end" aria-label="enforcedate" onClick={handleLastResultDownload}>
                <DownloadIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
            <br />
            {createFieldUpdateForJSON()}
            <br />
            {createTree()}
            <br />
          </>
        ) : (
          <>
            {createFieldUpdateForJSON()}
            <br />
            {createTree()}
            <br />
          </>
        );
        return (
          <>
            {lastResult}
          </>
        );
      }

      // 更新中エラー
      return (
        <>
          <Typography variant="body1" component="span">体系目次または分野の更新中です。</Typography>
          <p />
          <Typography variant="body1" component="span">しばらく待ってから再度お試しください。</Typography>
        </>
      );
    }
    return '';
  };

  const handleMoveAct = (fieldId: string, actId: string) => {
    setSelectedMoveAct(actId);
    setSelectedMoveField(fieldId);
    setMoveActDialog(true);
  };

  const fFieldsForFieldId = (fs: Field[], fieldId: string): undefined | Field => {
    let field: undefined | Field = undefined;
    for (const f of fs) {
      if (f.id === fieldId) {
        field = f;
        break;
      }
    };
    return field;
  };
  // const handleUpAct = (fieldId: string, actId: string) => {
  //   props.setLoading(true);
  //   const fs: Field[] = JSON.parse(JSON.stringify(props.fields));
  //   const field = fFieldsForFieldId(fs, fieldId);
  //   if (field) {
  //     const targetI = field.acts.findIndex((a) => a.actId === actId);
  //     [field.acts[targetI - 1], field.acts[targetI]] = [field.acts[targetI], field.acts[targetI - 1]];
  //     props.renewFields(fs);
  //   }
  //   props.setLoading(false);
  // };
  // const handleDownAct = (fieldId: string, actId: string) => {
  //   props.setLoading(true);
  //   const cs: Field[] = JSON.parse(JSON.stringify(props.fields));
  //   const field = fFieldsForFieldId(cs, fieldId);
  //   if (field) {
  //     const targetI = field.acts.findIndex((a) => a.actId === actId);
  //     [field.acts[targetI], field.acts[targetI + 1]] = [field.acts[targetI + 1], field.acts[targetI]];
  //     props.renewFields(cs);
  //   }
  //   props.setLoading(false);
  // };

  const createActsAction = (ir: number, length: number, fieldId: string, actId: string) => {
    // const moveup = ir !== 0 ? (
    //   <Tooltip title="表示順を1つ上に移動する">
    //     <IconButton sx={{
    //       color: (theme) => theme.palette.secondary.main,
    //       margin: 1,
    //     }} edge="end" aria-label="addCatalog" onClick={() => handleUpAct(fieldId, actId)}>
    //       <MoveUpIcon />
    //     </IconButton>
    //   </Tooltip>
    // ) : '';
    // const movedown = ir < length - 1 ? (
    //   <Tooltip title="表示順を1つ下に移動する">
    //     <IconButton sx={{
    //       color: (theme) => theme.palette.secondary.main,
    //       margin: 1,
    //     }} edge="end" aria-label="addCatalog" onClick={() => handleDownAct(fieldId, actId)}>
    //       <MoveDownIcon />
    //     </IconButton>
    //   </Tooltip>
    // ) : '';
    return (
      <>
        <Tooltip title="分野を移動する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleMoveAct(fieldId, actId)}>
            <DriveFileMoveOutlineIcon />
          </IconButton>
        </Tooltip>
        {/* {moveup}
        {movedown} */}
      </>
    );
  };

  const createActs = (level: number, fieldId: string, acts: Act[], view: React.JSX.Element[]) => {
    const lview: React.JSX.Element[] = [];
    acts.forEach((r, ir) => {
      lview.push(
        <div key={`result-${level}-${fieldId}-${r.actId}-${ir}`}>
          <ListItem secondaryAction={
            createActsAction(ir, acts.length, fieldId, r.actId)
          }>
            <ListItemIcon sx={{
              color: (theme) => theme.palette.primary.main,
              margin: 1,
            }}>
              <NoteIcon />
            </ListItemIcon>
            <ListItemText primary={
              <>
                <Typography variant="body1" component="span" sx={{
                  display: 'inline-block',
                  width: '70%',
                  verticalAlign: 'middle',
                }} >{r.title}</Typography>
              </>
            } secondary={
              <>
                <Typography variant="subtitle1" component="span">番号：</Typography>
                <Typography variant="body1" component="span">{r.actNum}</Typography>
              </>
            } />
          </ListItem>
          <Divider />
        </div>
      );
    });
    view.push(
      <Paper key={`acts-${level}-${fieldId}`}
        sx={{
          minWidth: 275,
          margin: 1,
          padding: 1,
          backgroundColor: (theme) => theme.palette.primary[50],
        }} elevation={3}>
        <List component="nav">
          {lview}
        </List>
      </Paper>
    );
  };

  const [fieldNameDialog, setFieldNameDialog] = React.useState(false);
  const openFieldNameDialog = Boolean(fieldNameDialog);
  const closeFieldNameDialog = () => setFieldNameDialog(false);
  const [fieldNameObject, setFieldNameObject] = React.useState<undefined | Field>(undefined);

  const setEditFieldName = (name: string) => {
    const f: Field = JSON.parse(JSON.stringify(fieldNameObject));
    f.name = name;
    setFieldNameObject(f);
  };

  const handleOkEditFieldName = (fieldId: string, name: string) => {
    const fs: Field[] = JSON.parse(JSON.stringify(props.fields));
    const field = fFieldsForFieldId(fs, fieldId);
    if (field) {
      field.name = name;
      props.renewFields(fs);
      setFieldNameObject(undefined);
    }
  };

  const handleEditFieldName = (f: Field) => {
    setFieldNameObject(f);
    setFieldNameDialog(true);
  };

  const [fieldAddDialog, setFieldAddDialog] = React.useState(false);
  const openFieldAddDialog = Boolean(fieldAddDialog);
  const closeFieldAddDialog = () => setFieldAddDialog(false);
  const [fieldAddObject, setFieldAddObject] = React.useState<undefined | Field>(undefined);
  const [fieldAddTargetObject, setFieldAddTargetObject] = React.useState<undefined | Field>(undefined);

  const setEditFieldAddName = (name: string) => {
    const f: Field = JSON.parse(JSON.stringify(fieldAddObject));
    f.name = name;
    setFieldAddObject(f);
  };

  const handleOkEditFieldAdd = () => {
    const f = (fs: Field[], fid: string): [number, Field[] | undefined] => {
      let i = 0;
      for (const f of fs) {
        if (f.id === fid) return [i, fs];
        i += 1;
      }
      return [-1, undefined];
    };
    const fs: Field[] = JSON.parse(JSON.stringify(props.fields));
    if (fieldAddTargetObject) {
      const [taegetIndex, targetFS] = f(fs, fieldAddTargetObject.id);
      if (targetFS && fieldAddObject) {
        targetFS.splice(taegetIndex + 1, 0, fieldAddObject);
        props.renewFields(fs);
        props.setMaxFieldId(Number(fieldAddObject.id));
      }
    }
  };

  const handleAddField = (f: Field) => {
    const newF: Field = JSON.parse(JSON.stringify(f));
    setFieldAddTargetObject(newF);
    const addF: Field = {
      id: '' + (props.maxFieldId + 1),
      name: '',
      acts: [],
    };
    setFieldAddObject(addF);
    setFieldAddDialog(true);
  }

  const handleDeleteField = (field: Field) => {
    const newFS: Field[] = JSON.parse(JSON.stringify(props.fields));

    const f = (fs: Field[]) => {
      let index = 0;
      for (const f of fs) {
        if (f.id === field.id) {
          fs.splice(index, 1);
          return true;
        }
        index += 1;
      }
      return false;
    };
    if (f(newFS)) {
      props.renewFields(newFS);
    }
  };

  const createFieldAction = (f: Field) => {
    return f.id === '0' ? (
      <>
        <Tooltip title="分野を次に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddField(f)}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
      </>
    ) : (f.acts.length === 0) ? (
      <>
        <Tooltip title="分野を削除する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleDeleteField(f)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="名称を編集する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleEditFieldName(f)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="分野を次に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddField(f)}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
      </>
    ) : (
      <>
        <Tooltip title="名称を編集する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="edit" onClick={() => handleEditFieldName(f)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="分野を次に追加する">
          <IconButton sx={{
            color: (theme) => theme.palette.secondary.main,
            margin: 1,
          }} edge="end" aria-label="addCatalog" onClick={() => handleAddField(f)}>
            <AddCircleIcon />
          </IconButton>
        </Tooltip>
      </>
    );
  };

  const createField = (f: Field) => {
    return (
      <FieldListItem secondaryAction={
        createFieldAction(f)
      } key={`catalog-${f.id}`}>
        <ListItemIcon><LabelIcon /></ListItemIcon>
        <ListItemText primary={f.name} />
      </FieldListItem>
    );
  }

  const [moveActDialog, setMoveActDialog] = React.useState(false);
  const openMoveActDialog = Boolean(moveActDialog);
  const closeMoveActDialog = () => {
    setMoveActDialog(false);
    setSelectedMoveAct('');
    setSelectedMoveField('');
  };

  const deleteActForField = (fields: Field[], actId: string): Act | undefined => {
    for (const field of fields) {
      const index = field.acts.findIndex(a => a.actId === actId);
      if (index !== -1) {
        const act = JSON.parse(JSON.stringify(field.acts[index]));
        field.acts.splice(index, 1);
        return act;
      }
    }
    return undefined;
  };
  const addActForField = (fields: Field[], fieldId: string, act: Act): boolean => {
    for (const field of fields) {
      if (field.id === fieldId) {
        field.acts.push(act);
        return true;
      }
    }
    return false;
  };
  const commitMoveActDialog = (fieldId: string, actId: string) => {
    props.setLoading(true);
    const f: Field[] = JSON.parse(JSON.stringify(props.fields));
    const act = deleteActForField(f, actId);
    if (act) {
      addActForField(f, fieldId, act);
      props.renewFields(f);
    }
    closeMoveActDialog();
    props.setLoading(false);
  };

  const [selectedMoveAct, setSelectedMoveAct] = React.useState('');
  const [selectedMoveField, setSelectedMoveField] = React.useState('');

  return (
    <>
      {createContents()}
      <FieldUpdateForJSONDialog
        open={openSubDialog}
        accountid={props.accountid}
        idid={props.idid}
        handleCommit={props.handleCommit}
        handleClose={closeSubDialog}
        setLoading={props.setLoading}
      />
      <FieldUpdateMoveActDialog
        open={openMoveActDialog}
        currentActId={selectedMoveAct}
        currentFieldId={selectedMoveField}
        fields={props.fields}
        handleClose={closeMoveActDialog}
        handleCommit={commitMoveActDialog}
      />
      <FieldUpdateAddFieldDialog
        open={openFieldAddDialog}
        field={fieldAddObject}
        setEditFieldName={setEditFieldAddName}
        handleCommit={handleOkEditFieldAdd}
        handleClose={closeFieldAddDialog}
      />
      <FieldUpdateNameDialog
        open={openFieldNameDialog}
        field={fieldNameObject}
        setEditFieldName={setEditFieldName}
        handleCommit={handleOkEditFieldName}
        handleClose={closeFieldNameDialog}
      />
      <Dialog
        open={openSubDialog2}
        keepMounted
        onClose={closeSubDialog2}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">分野の登録</DialogTitle>
        <DialogContent>
          <Typography>{'この処理には時間がかかる場合があります。よろしいですか？'}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={okSubDialog2} color="primary">
            OK
          </Button>
          <Button onClick={closeSubDialog2} color="primary">
            キャンセル
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};